import * as React from 'react'
import { makeStyles, /*withStyles*/ } from '@material-ui/core/styles'
import { Grid, Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core'
import FullContainerWidth from './FullContainerWidth'
import { BasicLabel } from '../../components/abstractObjects/Label'
//import { Translation } from '../../features/translations/getTranslation'

//export const ExpandablePanel = withStyles({
//    root: {
//        border: '1px solid white',
//        borderWidth: '0 0 5px 0',
//        '&:before': {
//            display: 'none',
//        },
//        '&$expanded': {
//            margin: 'auto',
//        }
//    },
//    expanded: {},
//})(Accordion)

//export const ExpandableSummary = withStyles({
//    root: {
//        backgroundColor: 'orange',
//        borderBottom: '1px solid rgba(0, 0, 0, .125)',
//        marginBottom: -1,
//        minHeight: 56,
//        '&$expanded': {
//            minHeight: 56,
//        },
//    },
//    content: {
//        '&$expanded': {
//            margin: '12px 0',
//        },
//    },
//    expanded: {},
//})(AccordionSummary)

//export const ExpandableDetails = withStyles((theme) => ({
//    root: {
//        padding: theme.spacing(2)
//    },
//}))(AccordionDetails)

const useStylesPanel = makeStyles((theme: any) => ({
    root: {
        border: '1px solid white',
        borderWidth: '0 0 5px 0',
        '&:before': {
            display: 'none',
        },
        //'&$expanded': {
        //    margin: 'auto',
        //}
    }
}))

const useStylesSummary = makeStyles((theme: any) => ({
    root: {
        backgroundColor: '#F26A21',
        borderBottom: '1px solid rgba(0, 0, 0, .125)',
        marginBottom: -1,
        minHeight: 56,
        color: "white",
        //'&$expanded': {
        //    minHeight: 56
        //},
    },
    content: {
        //'&$expanded': {
        //    margin: '0 0',
        //}
    },
    secondaryExpandable: {
        backgroundColor: '#FFFFFF',
        border: '3px solid #F26A21',
        color: 'black',
        fontWeight: 500,
        marginBottom: -1,
        minHeight: 56,
    }
}))

const useStylesDetails = makeStyles((theme: any) => ({
    root: {
        padding: theme.spacing(2)
    }
}))

export const ExpandableObject = (props: any) => {
    const classesPanel = useStylesPanel()
    const classesSummary = useStylesSummary()
    const classesDetails = useStylesDetails()

    return (
        <Accordion className={classesPanel.root} style={{ margin: 0 }} expanded={props.expanded} onChange={props.onChange}>
            <AccordionSummary className={props.class == "secondaryExpandable" ? classesSummary.secondaryExpandable : classesSummary.root}>
                <Grid item xs={11}><BasicLabel text={props.name} /></Grid>
                <Grid item xs={1}>
                    <i className={props.summaryClassName !== undefined ? props.summaryClassName : "fas fa-angle-down"} />
                </Grid>
            </AccordionSummary>
            <AccordionDetails className={classesDetails.root} style={props.styleDetail}>
                <FullContainerWidth>
                    {props.children}
                </FullContainerWidth>
            </AccordionDetails>
        </Accordion>
    )
}